export const MAX_HORIZONTAL_PANEL_WIDTH = '515px';
